import styled from "styled-components";

export const Container = styled.div`
	padding: 0px 0px 2rem;
`;
export const FooterButtons = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	padding: 0 0 2rem;

	> button {
		max-width: 200px;
	}
`;
